import React from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'

import { Field } from 'react-final-form'

import TextField from '../../ui/Fields/TextField'
import Select from '../../ui/Fields/Select'

import styles from '../../../../v4/theme/styles/forms'

export const validate = values => {
  const fields = ['equipment_id', 'measured_at', 'variable', 'value', 'justification']
  const errors = {}

  fields.forEach(field => {
    if (!values[field] && values[field] !== 0) errors[field] = I18n.t('validations.required')
  })

  return errors
}

// Mesmo rotulo usado no filtro da listagem.
const variableLabel = name =>
  I18n.t(`v4/equipment_measures.variables.${name}`, { defaultValue: name })

const Form = ({ classes, editing, handleSubmit, title, variables, o, backUrl }) => (
  <form className={classes.form} onSubmit={handleSubmit} data-testid='equipment-measures-form'>
    <Paper className={classes.form__wrapper} elevation={0}>
      <header className={classes.form__header}>
        <Typography component='h2' variant='h5'>
          {title}
        </Typography>
      </header>
      <main className={classes.form__fields}>
        <div className={classes.form__field__wrapper}>
          <Field
            component={TextField}
            className={classes.form__fieldWithError}
            margin='normal'
            fullWidth
            InputLabelProps={{ shrink: true }}
            variant='outlined'
            label={I18n.t('v4/equipment_measures.form.equipment_id')}
            name='equipment_id'
            required
            disabled={editing}
          />
        </div>
        <div className={classes.form__field__wrapper}>
          <Field
            component={TextField}
            className={classes.form__fieldWithError}
            margin='normal'
            fullWidth
            InputLabelProps={{ shrink: true }}
            variant='outlined'
            label={I18n.t('v4/equipment_measures.form.measured_at')}
            placeholder='YYYY-MM-DD HH:MM'
            name='measured_at'
            required
            disabled={editing}
          />
        </div>
        <div className={classes.form__field__wrapper}>
          <Field
            component={Select}
            className={classes.form__fieldWithError}
            InputLabelProps={{ shrink: true, required: true }}
            label={I18n.t('v4/equipment_measures.form.variable')}
            name='variable'
            fields={{ id: 'id', name: 'name' }}
            data={variables.map(name => ({ id: name, name: variableLabel(name) }))}
            fullWidth
            margin='normal'
            variant='outlined'
            required
            disabled={editing}
          />
        </div>
        <div className={classes.form__field__wrapper}>
          <Field
            component={TextField}
            className={classes.form__fieldWithError}
            margin='normal'
            fullWidth
            InputLabelProps={{ shrink: true }}
            variant='outlined'
            label={I18n.t('v4/equipment_measures.form.value')}
            name='value'
            required={!editing}
          />
        </div>
        <div className={classes.form__field__wrapper}>
          <Field
            component={TextField}
            className={classes.form__fieldWithError}
            margin='normal'
            fullWidth
            multiline
            rows={2}
            InputLabelProps={{ shrink: true }}
            variant='outlined'
            label={I18n.t('v4/equipment_measures.form.justification')}
            placeholder={I18n.t('v4/equipment_measures.form.justification_placeholder')}
            name='justification'
            required
          />
        </div>
      </main>
      <footer className={classes.form__actions}>
        <Button
          className={classes.form__action}
          color='primary'
          type='submit'
          variant='contained'
        >
          {title}
        </Button>

        <Button
          className={classes.form__action}
          color='secondary'
          href={backUrl || `/v4/o/${o}/admin/equipment_measures`}
        >
          {I18n.t('v4/equipment_measures.form.back')}
        </Button>
      </footer>
    </Paper>
  </form>
)

Form.propTypes = {
  title: PropTypes.string.isRequired
}

Form.defaultProps = {
  variables: [],
  editing: false
}

export default withStyles(styles)(Form)
